import { render } from "./TotalSearch.vue?vue&type=template&id=52f16668&scoped=true"
import script from "./TotalSearch.vue?vue&type=script&lang=js"
export * from "./TotalSearch.vue?vue&type=script&lang=js"

import "./TotalSearch.vue?vue&type=style&index=0&id=52f16668&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f16668"]])

export default __exports__